import {
  ShoppingBag,
  ShoppingCart,
  Settings,
  Folder,
  Grid,
  List,
  Star,
  Heart,
  User,
  Package,
  Calendar,
  Sparkles,
  Tag,
  Gift,
  Home,
  Menu,
  LayoutGrid,
  Palette,
  Layers,
  Percent,
} from "lucide-react";

export const iconMap = {
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  settings: Settings,
  grid: Grid,
  list: List,
  star: Star,
  heart: Heart,
  user: User,
  package: Package,
  calendar: Calendar,
  sparkles: Sparkles,
  tag: Tag,
  gift: Gift,
  home: Home,
  menu: Menu,
  "layout-grid": LayoutGrid,
  palette: Palette,
  layers: Layers,
  percent: Percent,
  default: Folder,
};
